import '../styles.css';

export default function Hero() {
  return (
    <section id="hero" className="fade-in">
      <div className="hero-grid">
        <div className="ascii-logo">
          <pre>{`
 ██╗  ██╗███╗   ██╗
 ██║ ██╔╝████╗  ██║
 █████╔╝ ██╔██╗ ██║
 ██╔═██╗ ██║╚██╗██║
 ██║  ██╗██║ ╚████║
 ╚═╝  ╚═╝╚═╝  ╚═══╝
          `}</pre>
        </div>
        <div className="system-info">
          <div className="info-line"><span className="info-label">OS</span><span className="info-value">Fresher</span></div>
          <div className="info-line"><span className="info-label">Host</span> <span className="info-value">Kartik Naik</span></div>
          <div className="info-line"><span className="info-label">Kernel</span> <span className="info-value">B.Tech CSE (2026)</span></div>
          <div className="info-line"><span className="info-label">Focus</span> <span className="info-value">Cloud & DevOps</span></div>
          <div className="info-line"><span className="info-label">Shell</span> <span className="info-value">bash & Python</span></div>
          {/* <div className="info-line"    ><span className="info-label">Editor</span> <span className="info-value">VS Code</span></div> */}
          <div className="info-divider"></div>
          <div className="info-line"><span className="info-label">Projects</span><span className="info-count">15+</span></div>
          <div className="info-line"><span className="info-label">Certs</span><span className="info-count">4+</span></div>
          <div className="info-line"><span className="info-label">Status</span><span className="info-status">● Open to Work</span></div>
        </div>
      </div>
    </section>
  );
}